import LiveReport from './LiveReport';
import { ReportDef } from './reportRegistry';

const AbilityMarkersReport = ({ report }: { report: ReportDef }) => <LiveReport report={report} kind="markers" />;

export default AbilityMarkersReport;
